import styles from "./OutletHighlightMessage.module.scss";
import { TickOutlined as Tick } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import classNames from "classnames/bind";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { OUTLET_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/OutletAccordion/OutletAccordionUI";

const cx = classNames.bind(styles);

const accordionInstances: Record<string, string> = {
  "#accordion-outlet": OUTLET_ACCORDION_INSTANCE_NAME,
};

function dispatchAccordionOpenEvent(target: string) {
  const event = new CustomEvent(
    `jlds:accordion:${accordionInstances[target]}`,
    {
      detail: { action: "open" },
    },
  );
  document.body.dispatchEvent(event);
}

export const OutletHighlightMessageUI = () => {
  const scrollToTarget = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const hrefTarget = e.currentTarget.getAttribute("href") || "";

    dispatchAccordionOpenEvent(hrefTarget);

    const scrollIntoView = () =>
      document
        .querySelector(hrefTarget)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(scrollIntoView, 0);
  };

  return (
    <div
      data-testid="product:outlet-highlight-message"
      data-component="OutletHighlightMessage"
    >
      <ul
        data-testid="product:outlet-highlight-message:list"
        className={cx(styles.list, {
          mobileGalleryExperience: false,
        })}
      >
        <li
          className={styles.item}
          key={`outlet-message`}
          data-testid="product:outlet-highlight-message:outlet"
        >
          <Tick size="medium" />
          <p className={styles.title}>
            Certified <span className={styles.bold}>Like new condition</span>{" "}
            from our{" "}
            <UnderlinedButton
              tag="a"
              data-testid="skiplinks:outlet"
              href="#accordion-outlet"
              onClick={scrollToTarget}
            >
              Outlet
            </UnderlinedButton>
          </p>
        </li>
      </ul>
    </div>
  );
};
